import { createSlice } from "@reduxjs/toolkit";
import { EXPIRES_KEY, ORIGIN_KEY, manualExpiresAt } from "src/utils/debug/monitorPolicy";

// ----------------------------------------------------------------------

// Rehidratamos `isMonitoring` desde localStorage — el toggle escribe
// `APIMONITOR_ENABLED=1|0` pero antes el initialState siempre partía en
// `false`, así al recargar el user veía el switch OFF pese a haberlo
// activado (los hooks reporters SÍ leían localStorage y seguían
// grabando; el switch quedaba desincronizado con la realidad).
const initialIsMonitoring = (() => {
  try {
    return window?.localStorage?.getItem("APIMONITOR_ENABLED") === "1";
  } catch {
    return false;
  }
})();

const initialState = {
  errors: [],
  lastError: null,
  isMonitoring: initialIsMonitoring,
  requests: [],
  hubError: [],
};

const slice = createSlice({
  name: "errors",
  initialState,
  reducers: {
    // payload `{ origin: "remote" }` desde la sesión de Live debug (la
    // caducidad ya la escribe el hook); sin payload = manual (Ajustes, /monitor)
    // y caduca a las 4 h: antes la manual grababa indefinidamente.
    startMonitoring(state, action) {
      state.isMonitoring = true;
      const origin = action?.payload?.origin === "remote" ? "remote" : "manual";
      try {
        window.localStorage.setItem("APIMONITOR_ENABLED", "1");
        window.localStorage.setItem(ORIGIN_KEY, origin);
        if (origin === "manual") {
          const ttlMs = Number(action?.payload?.ttlMs) > 0 ? Number(action.payload.ttlMs) : null;
          window.localStorage.setItem(
            EXPIRES_KEY,
            ttlMs ? new Date(Date.now() + ttlMs).toISOString() : manualExpiresAt(Date.now()),
          );
        }
      } catch { /* ignore */ }
    },
    stopMonitoring(state) {
      state.isMonitoring = false;
      try {
        window.localStorage.setItem("APIMONITOR_ENABLED", "0");
        // Fase 5 · Al apagar (manual o remoto) se olvida la caducidad pendiente.
        window.localStorage.removeItem(EXPIRES_KEY);
        window.localStorage.removeItem(ORIGIN_KEY);
      } catch { /* ignore */ }
    },

    resetMonitor(state) {
      state.errors = [];
      state.requests = [];
      state.hubError = [];
      state.lastError = null;
    },

    addErrors(state, action) {
      let errors = [action.payload, ...state.errors];

      state.lastError = action.payload;
      state.errors = errors.slice(0, 1000);
    },
    addRequests(state, action) {
      let requests = [action.payload, ...state.requests];

      state.requests = requests.slice(0, 1000);
    },

    addHubErrors(state, action) {
      let errors = [action.payload, ...state.hubError];

      state.hubError = errors.slice(0, 1000);
    },

    cleanLastError(state) {
      state.lastError = null;
    },
  },
});

export default slice.reducer;
export const {
  startMonitoring,
  stopMonitoring,
  resetMonitor,
  addErrors,
  addRequests,
  addHubErrors,
  cleanLastError,
} = slice.actions;
